<template>
  <div class="h-full w-full overflow-auto">
    <div
      class="border-b border-mid-neutral-50 h-14 flex items-center justify-between px-6 sticky top-0 left-0 bg-white z-10"
    >
      <slot name="header" />
    </div>
    <div class="w-full min-h-0">
      <slot />
    </div>
  </div>
</template>
